import { useMemo } from "react";
import { useGetTenantPublicConfigQuery } from "../graphql/generated/graphql";

export function useIframeAllowedDomains(): string[] | undefined {
  // This lightweight query is safe for Faculty, School Admin, and Admin.
  const { data } = useGetTenantPublicConfigQuery({ fetchPolicy: "cache-first" });

  return useMemo(() => {
    const tenant = data?.getTenantPublicConfig?.data?.[0];
    return tenant?.htmlEmbedAllowedDomains?.filter(Boolean) as string[] | undefined;
  }, [data]);
}